import { LogoIcon } from './Logo';

export default function NotFound({ onGoHome }) {
  return (
    <div className="nf-page">
      <div className="nf-logo">
        <LogoIcon size={36} />
        <span className="nf-logo-name">Acy<span className="logo-store-text">Mart</span></span>
      </div>
      <div className="nf-content">
        <div className="nf-code">404</div>
        <h1 className="nf-title">Page Not Found</h1>
        <p className="nf-desc">The page you're looking for doesn't exist or you don't have permission to view it.</p>
        <button className="btn nf-home-btn" onClick={onGoHome}>Go to Homepage</button>
      </div>
    </div>
  );
}
